module.exports = __webpack_public_path__ + "static/img/first-screen.f4656a15.png";